import CryptoJS from 'crypto-js';
const AES_KEY = 'oRzJszFoQJMDtHYg';
/**
 * AES-256-CBC 加密
 */
export function encryptAES(plaintext) {
    const encrypted = CryptoJS.AES.encrypt(plaintext, AES_KEY, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}
/**
 * 生成UUID
 */
export function generateUUID() {
    // 生成随机字符串 + 时间戳
    const randomStr = CryptoJS.lib.WordArray.random(16).toString();
    const timestamp = new Date().getTime();
    // 使用 MD5 哈希生成 UUID 格式
    const hash = CryptoJS.MD5(randomStr + timestamp).toString();
    // 格式化为 UUID 样式
    return (hash.substring(0, 8) + '-' +
        hash.substring(8, 12) + '-' +
        hash.substring(12, 16) + '-' +
        hash.substring(16, 20) + '-' +
        hash.substring(20, 32));
}
/**
 * Md5
 */
export function MD5(text) {
    return CryptoJS.MD5(text);
}
